import { Button, Modal, Popover } from "flowbite-react";
import { PinInput } from "./PinInput";
import PNGFromBytes from "./ImageFromBytes";
import { GrCircleInformation } from "react-icons/gr";
import { useState } from "react";

export default function UserConfirmationModal({
  show,
  onClose,
  handleSubmit,
  qrCodeBytes,
}) {
  const [TOTP, setTOTP] = useState("");
  const [emailPin, setEmailPin] = useState("");
  return (
    <div className="container z-20">
      <Modal show={show} onClose={() => onClose()}>
        <Modal.Header>Pin modal</Modal.Header>
        <Modal.Body className="flex flex-col items-center justify-center space-y-5 text-black dark:text-white">
          <div className="flex items-center justify-center space-x-2">
            <span>Scan this QR code to with your authentificator app </span>

            <Popover trigger="hover" content={QRCodeDecription()}>
              <button>
                <GrCircleInformation />
              </button>
            </Popover>
          </div>

          <div>
            <PNGFromBytes className="size-[200px]" byteString={qrCodeBytes} />
          </div>
          <PinInput length={6} setPin={setTOTP} />
          <div className="flex items-center justify-center space-x-2">
            <span>Enter the confirmation pin sent via email</span>

            <Popover trigger="hover" content={emailPinDescription()}>
              <button>
                <GrCircleInformation />
              </button>
            </Popover>
          </div>
          <PinInput setPin={setEmailPin} />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => handleSubmit(TOTP, emailPin)}>Submit</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
function QRCodeDecription() {
  return (
    <div className="w-64 text-sm text-gray-500 dark:text-gray-400">
      <div className="border-b border-gray-200 bg-gray-100 px-3 py-2 dark:border-gray-600 dark:bg-gray-700">
        <h3 className="font-semibold text-gray-900 dark:text-white"></h3>
      </div>
      <div className="px-3 py-2">
        <p>
          Scan the following QR code using your authentificator applcation (ex.
          Google Authentificator) after that introduce the generated code in the
          fields below
        </p>
      </div>
    </div>
  );
}

function emailPinDescription() {
  return (
    <div className="w-64 text-sm text-gray-500 dark:text-gray-400">
      <div className="border-b border-gray-200 bg-gray-100 px-3 py-2 dark:border-gray-600 dark:bg-gray-700">
        <h3 className="font-semibold text-gray-900 dark:text-white"></h3>
      </div>
      <div className="px-3 py-2">
        <p>
          The email sent to you contains a 4 digit code that you need to
          introduce in the fields below
        </p>
      </div>
    </div>
  );
}
